import { chartsType } from "App";
import dayjs from "dayjs";
import { VitalsChartData } from "hooks/types";
import { useMemo } from "react";
import BloodPressureLineChart from "./BloodPressureLineChart";
import BMILineChart from "./BMILineChart";
import HeartRateLineChart from "./HeartRateLineChart";
import HeightLineChart from "./HeightLineChart";
import RespiratoryRateLineChart from "./RespiratoryRateLineChart";
import TemperatureLineChart from "./TemperatureLineChart";
import WeightLineChart from "./WeightLineChart";

type ChartsProps = {
  vitalsChartData: VitalsChartData;
  chartsToDisplay: string[];
  handleToggleDisplayCharts: (chart: chartsType) => void;
};
const Charts = ({
  vitalsChartData,
  chartsToDisplay,
  handleToggleDisplayCharts,
}: ChartsProps) => {
  const parsedData = useMemo(() => {
    const labels = Object.keys(vitalsChartData).sort();
    const bpd: (string | null)[] = [];
    const bps: (string | null)[] = [];
    const pulse: (string | null)[] = [];
    const temperature: (string | null)[] = [];
    const height: (string | null)[] = [];
    const respiration: (string | null)[] = [];
    const weight: (string | null)[] = [];
    const bmi: (string | null)[] = [];
    const date: (string | null)[] = [];

    labels.forEach((label) => {
      const firstItem = vitalsChartData[label][0];

      if (firstItem && firstItem.bpd) {
        bpd.push(firstItem.bpd);
      } else {
        bpd.push(null);
      }
      if (firstItem && firstItem.date) {
        date.push(dayjs(firstItem.date).format("HH:mm:ss"));
      } else {
        date.push(null);
      }
      if (firstItem && firstItem.bps) {
        bps.push(firstItem.bps);
      } else {
        bps.push(null);
      }
      if (firstItem && firstItem.pulse) {
        pulse.push(firstItem.pulse);
      } else {
        pulse.push(null);
      }

      if (firstItem && firstItem.temperature) {
        temperature.push(Number(firstItem.temperature).toFixed(2));
      } else {
        temperature.push(null);
      }

      if (firstItem && firstItem.height) {
        height.push(Number(firstItem.height).toFixed(2));
      } else {
        height.push(null);
      }

      if (firstItem && firstItem.respiratoryRate) {
        respiration.push(firstItem.respiratoryRate);
      } else {
        respiration.push(null);
      }

      if (firstItem && firstItem.weight) {
        weight.push(firstItem.weight);
      } else {
        weight.push(null);
      }

      if (firstItem && firstItem.bmi) {
        bmi.push(Number(firstItem.bmi).toFixed(2));
      } else {
        bmi.push(null);
      }
    });
    return {
      labels,
      bpd,
      bps,
      pulse,
      temperature,
      height,
      weight,
      bmi,
      respiration,
      date,
    };
  }, [vitalsChartData]);
  return (
    <div className="space-y-4">
      <BloodPressureLineChart
        chartData={parsedData}
        chartsToDisplay={chartsToDisplay}
        handleToggleDisplayCharts={handleToggleDisplayCharts}
      />
      <HeartRateLineChart
        chartData={parsedData}
        chartsToDisplay={chartsToDisplay}
        handleToggleDisplayCharts={handleToggleDisplayCharts}
      />
      <TemperatureLineChart
        chartData={parsedData}
        chartsToDisplay={chartsToDisplay}
        handleToggleDisplayCharts={handleToggleDisplayCharts}
      />
      <BMILineChart
        chartData={parsedData}
        chartsToDisplay={chartsToDisplay}
        handleToggleDisplayCharts={handleToggleDisplayCharts}
      />
      <WeightLineChart
        chartData={parsedData}
        chartsToDisplay={chartsToDisplay}
        handleToggleDisplayCharts={handleToggleDisplayCharts}
      />
      <HeightLineChart
        chartData={parsedData}
        chartsToDisplay={chartsToDisplay}
        handleToggleDisplayCharts={handleToggleDisplayCharts}
      />
      <RespiratoryRateLineChart
        chartData={parsedData}
        chartsToDisplay={chartsToDisplay}
        handleToggleDisplayCharts={handleToggleDisplayCharts}
      />
    </div>
  );
};

export default Charts;
